export enum PortalMode {
  Default,
  Borgenar
}
